import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { bienestarService } from '../../services/api';
import { formatAgendaWhen, navigateTo } from './bienestarNav';

export function BienestarAgendaSnippet({ serviceSlug, limit = 3 }) {
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    bienestarService.getAgenda(limit, serviceSlug)
      .then((res) => {
        if (cancelled) return;
        const data = res?.data || res;
        setEvents(Array.isArray(data?.events) ? data.events : []);
      })
      .catch(() => {
        if (!cancelled) setEvents([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [serviceSlug, limit]);

  return (
    <section className="bw-section bw-agenda bw-agenda--snippet" aria-labelledby={`agenda-snippet-${serviceSlug}`}>
      <header className="bw-section-header">
        <h2 id={`agenda-snippet-${serviceSlug}`} className="bw-section-title">{t('bienestarHub.agendaSnippetTitle')}</h2>
      </header>
      {loading ? (
        <p className="bw-agenda-empty">{t('bienestarHub.agendaLoading')}</p>
      ) : events.length === 0 ? (
        <p className="bw-agenda-empty">{t('bienestarHub.agendaSnippetEmpty')}</p>
      ) : (
        <ul className="bw-agenda-list">
          {events.map((ev) => (
            <li key={`${ev.serviceSlug}-${ev.scheduledAt}`} className="bw-agenda-item">
              <span className="bw-agenda-when">
                <i className="fas fa-clock" aria-hidden="true" />
                {formatAgendaWhen(ev.scheduledAt, i18n.language)}
              </span>
              <span className="bw-agenda-badge">{t('bienestarHub.agendaSessionBadge')}</span>
            </li>
          ))}
        </ul>
      )}
      <p className="bw-agenda-foot">
        <button type="button" className="bw-link-btn" onClick={() => navigateTo('/bienestar#agenda-del-mes')}>
          {t('bienestarHub.agendaViewFull')}
        </button>
      </p>
    </section>
  );
}

export function BienestarAgendaFull() {
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    bienestarService.getAgenda(20)
      .then((res) => {
        if (cancelled) return;
        const data = res?.data || res;
        setEvents(Array.isArray(data?.events) ? data.events : []);
      })
      .catch(() => { if (!cancelled) setEvents([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="agenda-del-mes" className="bw-section bw-agenda">
      <header className="bw-section-header">
        <h2 className="bw-section-title">{t('bienestarHub.agendaTitle')}</h2>
        <p className="bw-section-sub">{t('bienestarHub.agendaSub')}</p>
      </header>
      {loading ? (
        <div className="bw-agenda-empty"><p>{t('bienestarHub.agendaLoading')}</p></div>
      ) : events.length === 0 ? (
        <div className="bw-agenda-empty">
          <i className="fas fa-calendar-alt" aria-hidden="true" />
          <p>{t('bienestarHub.agendaEmpty')}</p>
        </div>
      ) : (
        <ul className="bw-agenda-list">
          {events.map((ev) => (
            <li key={`${ev.serviceSlug}-${ev.scheduledAt}`} className="bw-agenda-item">
              <span className="bw-agenda-when">
                <i className="fas fa-clock" aria-hidden="true" />
                {formatAgendaWhen(ev.scheduledAt, i18n.language)}
              </span>
              <span className="bw-agenda-what">{ev.serviceName}</span>
              <span className="bw-agenda-badge">{t('bienestarHub.agendaSessionBadge')}</span>
            </li>
          ))}
        </ul>
      )}
      <p className="bw-agenda-foot">
        {t('bienestarHub.agendaRescheduleHint')}{' '}
        <button type="button" className="bw-link-btn" onClick={() => navigateTo('/bienestar/reprogramar')}>
          {t('bienestarHub.agendaRescheduleCta')}
        </button>
      </p>
    </section>
  );
}
